import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import { MuxPlayerComponent, MuxPlayerEventDetail } from '@outlaw/media';

@Component({
  selector: 'app-stream',
  standalone: true,
  templateUrl: './stream.component.html',
  styleUrls: ['./stream.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MuxPlayerComponent],
})
export class StreamComponent {
  @Input() streamUrl: string;
  @Input() playbackId: string;
  @Input() playbackToken: string;
  @Input() watchedDuration: number;
  @Input() poster: string;
  @Input() controls = true;
  @Input() muted: boolean;
  @Input() loop = false;
  @Output() sendVideoProgress = new EventEmitter<number>();
  @Output() sendProgressPercent = new EventEmitter<number>();
  @Output() videoFinished = new EventEmitter<boolean>();
  @Output() videoPausedProgress = new EventEmitter<number>();
  @ViewChild('player') player: MuxPlayerComponent;
  volume = 1;

  private get playerElement(): HTMLMediaElement | null {
    return this.player?.getPlayerElement() as unknown as HTMLMediaElement;
  }

  private _activatePlay: boolean;
  @Input() set activatePlay(v: boolean) {
    setTimeout(() => {
      if (!this._activatePlay && v) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
      this._activatePlay = v;
    }, 200);
  }

  playVideo(): void {
    const el = this.playerElement;
    if (el?.play) {
      el.play();
    }
  }

  pauseVideo(): void {
    const el = this.playerElement;
    if (el?.pause) {
      el.pause();
    }
  }

  onPause(event: MuxPlayerEventDetail): void {
    if (event.currentTime !== undefined) {
      this.sendVideoProgress.emit(event.currentTime);
      const percentProgress = this.calculateProgress(event);
      this.sendProgressPercent.emit(percentProgress);
      this.videoPausedProgress.emit(percentProgress);
    }
  }

  onTimeUpdate(_event: MuxPlayerEventDetail): void {
    // Can be used for progress tracking if needed
  }

  onEnded(): void {
    this.videoFinished.emit(true);
  }

  onError(event: MuxPlayerEventDetail): void {
    console.log('error event', event);
  }

  private calculateProgress(event: MuxPlayerEventDetail): number {
    if (!event.currentTime || !event.duration) return 0;
    return (event.currentTime / event.duration) * 100;
  }
}
